import useHttp from "hooks/useHttp";
import AppRoutes from "./routes";
import { Fragment } from "react/jsx-runtime";
import useStore from "hooks/useStore";
import { useEffect } from "react";

function App() {
  const { configureHeaders, configureInterceptors } = useHttp();

  const { setLoading } = useStore();

  configureInterceptors();
  useEffect(() => {
    setLoading(false);
    configureHeaders();
  }, []);

  return (
    <Fragment>
      <AppRoutes />
    </Fragment>
  );
}

export default App;
